import CandidateSortBy, { CandidateSortByProps } from './CandidateSortBy.component';

export type CandidateSortByType = CandidateSortByProps;

export default CandidateSortBy;
